<template>
  <c-modal
    
    v-model="modal"
    cancel-label="Cancel"
    centered size="md"
    title="Confirmation"
    :tag="false"
    @hide="hide"
    confirm-label="Confirm & Continue"
    :progressing="loading"
    @show="showModal"
    @submit="submit">

    <template>
    
      <div v-if="showAsap">
        <div class="text-center font-weight-bold h5 mb-0">
          Pickup time is: {{getCurrentHour()}}
        </div>
      </div>
      <div v-else>
        <b-form-group v-if="dates.length">
          <b-input-group :prepend="'Pickup Date'">
            <b-form-select
              :name="'Pickup Date'"
              v-validate="'required'"
              :options="dates"
              v-model="date"
              @input="changeDate"
            />
          </b-input-group>
        </b-form-group>

        <b-form-group v-if="times.length" class="mb-0">
          <b-input-group :prepend="getTimeLabel">
            <b-form-select
              :name="getTimeLabel"
              v-validate="'required'"
              :options="times"
              v-model="time"/>
          </b-input-group>
        </b-form-group>
      </div>
    
    </template>

  </c-modal>
  
</template>

<script>
  import CModal from "../../shared/Cmodal";
  import moment from "moment";
  import EditForm from "../EditForm";
  export default {
    name: "confirmTime",
    components: {CModal},
    mixins: [EditForm],
    props: {
      value: {required: true, type: Boolean, default: false},
      EnableScheduledPickup: {type: Boolean, default: false},
      order: {type: Object, default: {}},
      loading: {type: Boolean, default: false},
      PreparationTime: {type: [String, Number], default: 0},
      createLink: {type: Boolean, default: false},
      opened: {type: Boolean, default: false},
      closed:{type:Function},
      byPass:{type: Boolean, default: false}
    },
    data () {
      return {
        times: [],
        time: null,
        dates: [],
        date: null,
        bypass: false
      }
    },
    computed: {
      modal: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      },
      getTimeLabel () {
        if (this.order.orderType === 1) return 'Pickup Time'
        if (this.order.orderType === 3) return 'Delivery Time'
      },
    },
    watch: {
        opened: {
            handler(newVal) {
                if (newVal === true ) {//auto bypass when there is only one time avaiable
                  this.bypass = true
                }
            }
        }
    },
    methods: {
      
      showModal () {
        if (this.order.orderType === 1) {
          if (this.order.specialMenuTypeId === -1) {
            if (this.showAsap) {
              this.time = this.getCurrentHour()
              if(this.byPass){
                this.submit()
              }
            } else {
              this.getAllPickUpTimes()
            }
          } else {
            this.getAllDates()
          }
        } else {
          this.getAllDeliveryTimes()
        }
      },
      getAllDates () {
        let model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem('userID'),
          ItemType: 'Food',
          ItemType: 'Food',
          MenuTypeID: this.order.specialMenuTypeId
        }
        return this.$api.getRestaurant.GetPickupDateByMenu(model).then(res => {
          if (res.success) {
            let array = []
            res.dates.forEach(item => {
              array.push({
                text: this.validDate(item),
                value: item
              })
            })
            
            this.dates = [...array]
              this.date = this.order.date
              this.getAllSpecialTime(this.date, this.order.specialMenuTypeId)
            
          }
        }).catch(() => {})
      },
      getAllSpecialTime (date, MenuTypeID) {
        let model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem('userID'),
          SelectedDate: date,
          MenuTypeID
        }
        return this.$api.getRestaurant.GetPickupTimes_Event(model).then(res => {
          if (res.success) {
            let array = []
            res.times.forEach((item, index) => {
              array.push({
                text: index === 0 ? item + ' (ASAP) ' : item,
                value: item
              })
            })
            this.times = [...array]
            const find = this.times.find(i => i.value === this.order.PickupTime)
            if (find) {
              this.time = find.value
            } else {
              this.time = this.times[0].value
            }
          }
        }).catch(err => {

        })
      },
      getAllPickUpTimes () {
        let model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem('userID'),
        }
        return this.$api.getRestaurant.GetPickupTimes(model).then(res => {
          if (res.success) {
            let array = []
            res.times.forEach((item, index) => {
              array.push({
                text: index === 0 ? item + ' (ASAP) ' : item,
                value: item
              })
            })
            this.times = [...array]
            const find = this.times.find(i => i.value === this.order.PickupTime)
            if(this.times.length === 0 && find === undefined){
              this.time = this.getCurrentHour()
              this.submit()
              this.hide()
              return
            }
            if (find) {
              this.time = find.value
            } else {
              this.time = this.times[0].value
            }
            if(this.bypass && this.times[0].value === this.order.PickupTime && this.order.orderType === 1){
              this.submit()
              this.hide()
              this.bypass = false
              return
            }
            if(this.bypass && this.times[0].value != this.order.PickupTime && this.order.orderType === 1){//if more than 10 mins has passed since placeing order time won't exist in this.times
              this.submit()
              this.hide()
              this.bypass = false
            }
            
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      getAllDeliveryTimes () {
        let model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          // UserID: localStorage.getItem('userID'),
        }
        return this.$api.getRestaurant.GetDeliveryTimes(model).then(res => {
          if (res.success) {
            let array = []
            res.listOfRestaurantDeliveryPeriod.forEach((item, index) => {
              array.push({
                text: index === 0 ? item.PickupTime + ' (ASAP) ' : item.PickupTime,
                value: item.PickupTime
              })
            })

            this.times = [...array]
            const find = this.times.find(i => i.value === this.order.PickupTime)
            if (find) {
              this.time = find.value
            } else {
              this.time = this.times[0].value
            }
          }
        }).catch(err => {

        })
      },
      changeDate (date) {
        this.getAllSpecialTime(date, this.order.specialMenuTypeId)
      },
      hide () {
        this.model = false
        //this.closed()
      },
      validDate (date) {
        moment.locale('en-ca');
        return moment(date).format('D MMM YY')
      },
      submit () {
        const model = this.order
        model.PickupTime = this.order.specialMenuTypeId === -1 ? this.time : this.date + ' ' + this.time
        if (model.orderType == 3) {
          if (this.createLink) {
            this.$emit('openConfirmMobile', model)
          } else {
            this.$emit('createDeliveryOrder', model)
          }
        } else {
          if (this.createLink) {
            this.$emit('openConfirmMobile', model)
          } else {
            this.$emit('createPickUpOrder', model)
          }
        }
      },
      getCurrentHour () {
        const currentTime = moment().locale('en').add(this.PreparationTime, 'minutes').format('hh:mm A')
        return currentTime
      }
    }
  }
</script>

<style scoped>

</style>
